import { config, debug, i18n, inject, observer, React, Route, RouteComponentProps, ui } from "aaa";
import { AliasManageUsername } from "components/alias/AliasManageUsername";
import { AliasManageUsernameSigning } from "components/alias/AliasManageUsernameSigning";
import { AliasManageUsernameSuccess } from "components/alias/AliasManageUsernameSuccess";
import ErrorScreen from "components/common/ErrorScreen";
import auth from "stores/AuthStore";
import externalInterfaceStore, { ExternalInterfaceStore } from "stores/ExternalInterfaceStore";
import { pushRoute, replaceRoute } from "stores/RouterFunctions";
import { history } from "stores/RouterStore";
import { GidSettingsHomeScreen } from "./GidSettingsHomeScreen";
import { GidSettingsLimit } from "./GidSettingsLimit";
import { GidSettingsLimitSigning } from "./GidSettingsLimitSigning";
import { GidSettingsRoutes } from "./GidSettingsRoutes";
import { GidSettingsStore } from "./GidSettingsStore";
import { AliasOverview } from "components/alias/AliasOverview";
import { GidSettingsLimitSuccess } from "./GidSettingsLimitSuccess";
import { AliasDeleteUsernameSigning } from "components/alias/AliasDeleteUsernameSigning";
import { AliasDeleteUsernameSuccess } from "components/alias/AliasDeleteUsernameSuccess";
import { GidSettingsDeleteSigning } from "./GidSettingsDeleteSigning";
import { GidSettingsDeleteSuccess } from "./GidSettingsDeleteSuccess";
import { CardTanSettingsRoutes } from "../cardTanSettings/CardTanSettingsRoutes";
import { SIdentitySettingsRoutes } from "../sIdentitySettings/SIdentitySettingsRoutes";

type IProps = RouteComponentProps & i18n.InjectedIntlProps & {
    externalInterfaceStore: ExternalInterfaceStore;
};

@i18n.injectIntl
@inject("externalInterfaceStore")
@observer
export default class GidSettingsContainer extends React.Component<IProps> {
    store: GidSettingsStore;

    constructor(props: IProps) {
        super(props);
        this.store = new GidSettingsStore();
    }

    async componentDidMount() {
        try {
            if (auth.authorized) {
                await this.store.loadSettings();
            }

            const authorizationType = externalInterfaceStore.settings?.authorizationType;

            if (history.location.pathname.startsWith(GidSettingsRoutes.LIMIT)) {
                if (history.location.pathname !== GidSettingsRoutes.LIMIT) {
                    replaceRoute(GidSettingsRoutes.LIMIT);
                }
            } else if (history.location.pathname.startsWith(GidSettingsRoutes.ONBOARDING_LIMIT)) {
                if (authorizationType === "GEORGE_TOKEN") {
                    if (history.location.pathname !== GidSettingsRoutes.ONBOARDING_LIMIT) {
                        replaceRoute(GidSettingsRoutes.ONBOARDING_LIMIT);
                    }

                    await this.store.loadLimits();
                    return;
                } else {
                    if (authorizationType === "CARDTAN") {
                        replaceRoute(CardTanSettingsRoutes.ONBOARDING_LIMIT);
                        return;
                    } else if (authorizationType === "SID") {
                        replaceRoute(SIdentitySettingsRoutes.ONBOARDING_LIMIT);
                        return;
                    }
                }
            } else if (history.location.pathname.startsWith(GidSettingsRoutes.USERMANAGEMENT)) {
                if (history.location.pathname !== GidSettingsRoutes.USERMANAGEMENT) {
                    replaceRoute(GidSettingsRoutes.USERMANAGEMENT);
                }
            } else if (history.location.pathname !== GidSettingsRoutes.ROOT) {
                pushRoute(GidSettingsRoutes.ROOT);
            }

            if (authorizationType !== "GEORGE_TOKEN") {
                replaceRoute(GidSettingsRoutes.ERROR_SIGNING_METHOD);
                return;
            }

            if (auth.authorized) {
                await this.store.loadData();
            }
        } catch (error) {
            debug.log("### GidSettingsContainer.componentDidMount() Failed to load data", error);

            if (!config.DEBUG) {
                pushRoute("/error");
            }
        }
    }

    withStore(Component: any) {
        return () => <Component {...this.props} store={this.store} />;
    }

    withAliasStore(Component: any) {
        return () => <Component {...this.props} store={this.store.aliasStore} />;
    }

    withMessage(Component: any, message: string, hideButton?: boolean) {
        return () => <Component {...this.props} useWebVersion variant="error" message={message} hideButton={hideButton} />;
    }

    render() {
        return (
            <div>
                {/* currently the homescreen is not necessary - subroutes are directly used by the native app */}
                {/* <Route exact path={GidSettingsRoutes.ROOT} component={this.withMessage(ErrorScreen, ui.__("error.pageNotFound"), true)} /> */}
                <Route exact path={GidSettingsRoutes.ROOT} component={this.withStore(GidSettingsHomeScreen)} />
                <Route
                    exact
                    path={GidSettingsRoutes.USERMANAGEMENT}
                    component={this.withAliasStore(AliasOverview)}
                />
                <Route
                    path={[GidSettingsRoutes.USERMANAGEMENT_USERNAME, GidSettingsRoutes.USERNAME]}
                    component={this.withAliasStore(AliasManageUsername)}
                />
                <Route
                    path={[GidSettingsRoutes.USERMANAGEMENT_USERNAME_SIGNING, GidSettingsRoutes.USERNAME_SIGNING]}
                    component={this.withAliasStore(AliasManageUsernameSigning)}
                />
                <Route
                    path={[GidSettingsRoutes.USERMANAGEMENT_USERNAME_SUCCESS, GidSettingsRoutes.USERNAME_SUCCESS]}
                    component={this.withAliasStore(AliasManageUsernameSuccess)}
                />
                <Route
                    path={[GidSettingsRoutes.USERMANAGEMENT_DELETE_USERNAME_SIGNING, GidSettingsRoutes.DELETE_USERNAME_SIGNING]}
                    component={this.withAliasStore(AliasDeleteUsernameSigning)}
                />
                <Route
                    path={[GidSettingsRoutes.USERMANAGEMENT_DELETE_USERNAME_SUCCESS, GidSettingsRoutes.DELETE_USERNAME_SUCCESS]}
                    component={this.withAliasStore(AliasDeleteUsernameSuccess)}
                />
                <Route path={GidSettingsRoutes.DELETE_DEVICE_SIGNING} component={this.withStore(GidSettingsDeleteSigning)} />
                <Route path={GidSettingsRoutes.DELETE_DEVICE_SUCCESS} component={this.withStore(GidSettingsDeleteSuccess)} />
                <Route exact path={GidSettingsRoutes.LIMIT} component={this.withStore(GidSettingsLimit)} />
                <Route exact path={GidSettingsRoutes.ONBOARDING_LIMIT} component={this.withStore(GidSettingsLimit)} />
                <Route path={GidSettingsRoutes.LIMIT_SUCCESS} component={this.withStore(GidSettingsLimitSuccess)} />
                <Route path={[GidSettingsRoutes.ONBOARDING_LIMIT_SIGNING, GidSettingsRoutes.LIMIT_SIGNING]} component={this.withStore(GidSettingsLimitSigning)} />
                <Route
                    path={GidSettingsRoutes.ERROR_SIGNING_METHOD}
                    render={this.withMessage(ErrorScreen, ui.__("sidentitySettings.error.signingMethod"))}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/loginManagement/gidSettings/GidSettingsContainer.tsx